module.exports = __webpack_public_path__ + "assets/8a79c92cb653650c3fc133234be64f5a.mp3";